import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 2D50B6E0-C01B-4EDE-BA85-A14757A27D54
 * name hospital-box-outline
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hospital-box-outline.svg
 * tags
 * - Medical / Hospital 
 */
export const HospitalBoxOutlineIcon = createSvgIcon(<><path d="M18 14H14V18H10V14H6V10H10V6H14V10H18M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2M20 20H4V4H20V20Z" /></>, 'HospitalBoxOutlineIcon');
export default HospitalBoxOutlineIcon